export default "__VITE_ASSET__bec30a5a__"